export default __webpack_public_path__ + "static/media/bg-login.8e2fe038.jpg";